import React, { useState, useEffect, useRef } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import { auth } from "../../actions/firebase";
import Loading from './../Loading';

function Login({ isLogined, location }) {
  const [, setUser] = useRecoilState(userState);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSaveEmail, setIsSaveEmail] = useState(false);
  const { from } = location.state || { from: { pathname: "/" } };
  const submitButtonRef = useRef();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      setEmail(email);
      setIsSaveEmail(true);
    }
  }, []);

  if (isLogined) {
    return <Redirect to={from} />;
  }

  const onFormSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      await auth.signInWithEmailAndPassword(email, password);
      const { data } = await awsInstance.post("business/company/sign-in", {
        email: email,
      });
      setLoading(false);
      if (data.code === "SUCCESS") {
        const user = data.data;
        // 관리자 승인 전 이동
        if (user.status === 100) {
          history.push("/register-success");
          // 관리자 승인 된 직원 이메일 발송
        } else if (user.status === 200 && !auth.currentUser.emailVerified) {
          await auth.currentUser
            .sendEmailVerification()
            .then(() => {
              history.push("/auth-mail");
            })
            .catch((e) => {
              if(e.code === "auth/too-many-requests"){
                alert("메일이 이미 전송 되었습니다. 1분 후 다시 시도해주세요.");
              } else {
                alert("메일 전송에 실패하였습니다.");
              }
            });
        } else {
          setUser(user);
          sessionStorage.setItem("user", JSON.stringify(user));
          history.push("/");
          if (isSaveEmail) {
            localStorage.setItem("email", email);
          } else {
            localStorage.removeItem("email");
          }
        }
      } else if (data.code === "NO_DATA") {
        alert("이메일 또는 비밀번호를 확인해주세요.");
      } else {
        alert(data.message);
      }
    } catch (e) {
      setLoading(false);
      if (
        e.code === "auth/user-not-found" ||
        e.code === "auth/wrong-password"
      ) {
        alert("이메일 또는 비밀번호를 확인해주세요.");
      } else {
        alert("로그인이 실패하였습니다.");
      }
    }
  };

  return (
    <>
    <div className="login">
      <form className="login-form mt-1 mb-1" onSubmit={onFormSubmit}>
        <h3>관리시스템</h3>
        <div className="input-area">
          <input
            className="form-control mb-3"
            type="text"
            placeholder="이메일"
            value={email}
            maxLength="100"
            onChange={(e) => setEmail(e.target.value)}
            style={{height:"3rem"}}
          />
          <input
            className="form-control mb-3"
            type="password"
            placeholder="비밀번호"
            value={password}
            maxLength="17"
            onChange={(e) => setPassword(e.target.value)}
            style={{height:"3rem"}}
          />
        </div>
        <div className="check-area display-flex space-between ml-3 mt-4 mb-2 txt-gray">
          <div className="remember-me ml-2">
            <input
              className="form-check-input"
              id="saveAccount"
              type="checkbox"
              checked={isSaveEmail}
              onChange={(event) => setIsSaveEmail(event.target.checked)}
            />
            <label
              className="form-check-label txt-gray font-small font-bold"
              htmlFor="saveAccount"
            >
              아이디 저장
            </label>
          </div>
          <div className="find-pw-area">
            <span>
              <Link
                className="txt-gray mr-1 font-small font-bold"
                to="/agreement"
              >
                회원가입
              </Link>
            </span>

            <span className="txt-gray font-normal">| </span>
            <span>
              <Link
                className="txt-gray font-small font-bold"
                to="/find-password"
              >
                비밀번호를 잊어버리셨나요?
              </Link>
            </span>
          </div>
        </div>
        <button
          className="btn btn-lg btn-blue mb-2 font-bold"
          type="submit"
          ref={submitButtonRef}
        >
          로그인
        </button>
        <span className="txt-gray float-right font-small font-bold">
          고객센터 070-7114-0418
        </span>
      </form>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default Login;
